import { AlertLevel, AlertLevelConfig } from '../types/security';

/**
 * Maps a numeric severity (0-4) to a 3-level alert system.
 * 0-1 → douce, 2-3 → forte, 4 → rouge
 */
export function mapSeverityToLevel(severity: number): AlertLevel {
  if (severity <= 1) return 'douce';
  if (severity <= 3) return 'forte';
  return 'rouge';
}

const ALERT_LEVEL_CONFIGS: Record<AlertLevel, AlertLevelConfig> = {
  douce: {
    label: 'Alerte Douce',
    emoji: '🟢',
    color: 'text-green-700',
    bgColor: 'bg-green-50',
    borderColor: 'border-green-400',
    severities: [0, 1],
  },
  forte: {
    label: 'Alerte Forte',
    emoji: '🟠',
    color: 'text-orange-700',
    bgColor: 'bg-orange-50',
    borderColor: 'border-orange-400',
    severities: [2, 3],
  },
  rouge: {
    label: 'Alerte Rouge',
    emoji: '🔴',
    color: 'text-red-700',
    bgColor: 'bg-red-50',
    borderColor: 'border-red-400',
    severities: [4],
  },
};

/**
 * Returns the visual configuration for a given alert level.
 */
export function getAlertLevelConfig(level: AlertLevel): AlertLevelConfig {
  return ALERT_LEVEL_CONFIGS[level];
}

interface AlertWithSeverity {
  severity: number;
  [key: string]: any;
}

export interface GroupedAlerts {
  douce: number;
  forte: number;
  rouge: number;
}

/**
 * Groups alerts by the 3 levels and returns counts.
 * The sum of all counts equals the total number of alerts.
 */
export function groupAlertsByLevel(alerts: AlertWithSeverity[]): GroupedAlerts {
  const result: GroupedAlerts = { douce: 0, forte: 0, rouge: 0 };
  for (const alert of alerts) {
    const level = mapSeverityToLevel(alert.severity);
    result[level]++;
  }
  return result;
}
